import React from 'react';
import awardsData from '../awards.json';
import './Awards.css';

// Content is edited in src/awards.json
const AWARDS = awardsData.awards;

// Helper: turns "text __name__ text" into JSX with <strong> around names
const renderAward = (text) => {
  const parts = text.split(/__([^_]+)__/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>
  );
};

function Awards() {
  const years = Object.keys(AWARDS).sort((a, b) => b - a);

  return (
    <div className="page awards-page">
      <div className="container-narrow">
        <header className="page-header">
          <h1>Awards &amp; Accolades</h1>
          <div className="accent-bar"></div>
        </header>

        <div className="awards-timeline">
          {years.map((year) => (
            <section key={year} className="awards-year">
              <div className="awards-year-label">
                <span className="awards-year-number">{year}</span>
              </div>
              <div className="awards-items">
                <ul>
                  {AWARDS[year].map((award, idx) => (
                    <li key={idx} className="award-item">
                      {renderAward(award)}
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Awards;
